import LocalStorageRepository from "@infra/repositories/LocalStorageRepository"

import { TransactionStatecontextBase } from "./default/TransactionContextBase"
import { CustomerResponse } from "@infra/models/PlateInfo"

export enum LocalStorageKey {
  TransactionBase = "transactionBase",
}
export const getBaseStorage = () => {
  const transactionBase = JSON.parse(
    LocalStorageRepository.get(LocalStorageKey.TransactionBase)
      ? (LocalStorageRepository.get(LocalStorageKey.TransactionBase) as string)
      : "{}"
  )
  const baseStorage: TransactionStatecontextBase =
    transactionBase as unknown as TransactionStatecontextBase
  return baseStorage
}

export const cleanBaseStorage = () => {
  LocalStorageRepository.set(
    LocalStorageKey.TransactionBase,
    JSON.stringify(new TransactionStatecontextBase())
  )
}

